/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { PureComponent } from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap';
import UserActionsComponent from '../../components/user-actions';
import UserActionsSummaryComponent from '../../components/user-actions-summary';

class UniversalTrackerManagement extends PureComponent {

  render() {
    let { location } = this.props;
    let activeTab;
    switch (location.hash) {
      case '#utr':
        activeTab = 'utr';
        break;
      default:
      case '#summary':
        activeTab = 'summary';
        break;
    }

    return (
      <div className='utr-management row'>
        <div className='col'>
          <div className='tabbed-header row'>
            <div className='col'>
              <h1 className='ml-2'>Universal Tracker Management</h1>
              {this.getTabs(activeTab)}
            </div>
          </div>
          <div className='row'>
            <div className='col mt-4'>
              {this.getContent(activeTab)}
            </div>
          </div>
        </div>
      </div>
    );
  }

  getContent(activeTab) {
    switch (activeTab) {
      case 'utr':
        return <UserActionsComponent />;
      case 'summary':
      default:
        return <UserActionsSummaryComponent />
    }
  }

  getTabs(activeTab) {
    return <Nav tabs className='justify-content-center'>
      <NavItem>
        <NavLink
          className={activeTab === 'summary' ? 'active' : ''}
          href='#summary'>
          Summary
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={activeTab === 'utr' ? 'active' : ''}
          href='#utr'>Universal Trackers
              </NavLink>
      </NavItem>
    </Nav>
  }

}

export default UniversalTrackerManagement;
